import { FileRouteTypes } from "../routeTree.gen";
import { HTMLAttributes, ReactNode } from "react";
import { Link } from "@/Link";
import { ThemeClassNames, withTheme } from "./withTheme";

interface AnchorProps extends HTMLAttributes<HTMLAnchorElement> {
  to: FileRouteTypes["to"];
  className?: string;
  children?: ReactNode;
  disabled?: boolean;
  /** TanStack Router 의 history replace 모드 (첫 뎁스 메뉴 등에서 사용) */
  replace?: boolean;
}
export const Anchor = ({
  to,
  className,
  children,
  disabled = false,
  replace,
  ...props
}: AnchorProps) => {
  return (
    <Link
      {...props}
      className={className}
      to={to}
      disabled={disabled}
      replace={replace}
      data-touch
    >
      {children}
    </Link>
  );
};

const className: ThemeClassNames = {
  primary: "bg-yellow text-white",
  secondary: "border-yellow border text-yellow",
  tertiary: "bg-[#E9E9E9]",
  quaternary: "border",
  md: "px-4 h-10 text-xs font-medium rounded",
  xl: "px-4 h-14 text-base",
};
export const ThemedAnchor = withTheme(Anchor, className);
